import { Component, computed, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductTab, SubTab, Tab, TabSection } from '../../../../shared/models/productsModel';
import { requestforEmulationPayload } from '../../../../shared/models/model';
import { WidgetsService } from '../../../../shared/services/widgets.service';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { EmulationService } from '../../../../shared/services/emulation.service';
import { SkeletonLineComponent } from '../../../../pages/skeleton-line/skeleton-line.component';
import config from '../../../../../assets/config.json';

/**
 * Component representing product tabs.
 *
 * @selector app-product-tabs
 * @templateUrl ./products.component.html
 * @styleUrls ./products.component.scss
 * @standalone true
 * @imports [CommonModule]
 */
@Component({
  selector: 'app-product-tabs',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, SkeletonLineComponent],
})
export class ProductTabsComponent implements OnInit, OnDestroy {
  /**
   * Array of product tabs.
   */
  tabs: ProductTab[] = [];

  subTabs: SubTab[] = [];

  sections: TabSection[] = [];

  public curentDomin: string = window.location.origin.includes('localhost') ? config.siteUrl : window.location.origin;

  productsSubscription: Subscription = new Subscription();

  emulatedUser = computed(() => this._emulationService.emulatedUser());
  isLoading: boolean = false;
  constructor(
    private _widgetService: WidgetsService,
    private _router: Router,
    private _emulationService: EmulationService,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    // Request payload
    const payload: requestforEmulationPayload = {
      requestingSystem: 'FinPro', // Requesting system
      isEmulating: this.emulatedUser() ? true : false,
      emulatingUserId: this.emulatedUser()?.userId || '',
    };
    // Fetch products
    this.productsSubscription = this._widgetService.fetchProducts(payload).subscribe(async (data: any) => {
      // Wait for 2 milliseconds before processing the response
      await new Promise((resolve) => setTimeout(resolve, 2000));
      if (data && data.tabs !== null && Array.isArray(data.tabs) && data.tabs.length > 0) {
        this.tabs = data.tabs.map((tab: Tab, index: number) => ({
          ...tab,
          isActive: index === 0,
          subTabs: tab.subTabs.map((subTab, subIndex) => ({
            ...subTab,
            isActive: subIndex === 0,
          })),
        }));
        this.subTabs = this.tabs[0].subTabs;
        this.sections = this.subTabs[0].sections;
      }
      this.isLoading = false;
    });
  }
  // On Tab selection
  selectTab(title: string): void {
    this.tabs.forEach((tab: ProductTab, index: number) => {
      this.tabs[index].isActive = tab.title === title;
      if (tab.isActive) {
        this.subTabs = tab.subTabs;
        this.sections = this.subTabs[0]?.sections || [];
      }
    });

    this.subTabs.forEach((subTab: SubTab, index: number) => {
      this.subTabs[index].isActive = index === 0;
    });
  }
  // On SubTab selection
  setView(view: string): void {
    const selectedTab = this.tabs.find((tab) => {
      return tab.isActive;
    });
    if (selectedTab) {
      const selectedView = selectedTab.subTabs.find((subTab) => {
        return subTab.subTitle === view;
      });
      if (selectedView) {
        selectedTab.subTabs.forEach((subTab: SubTab, index: number) => {
          selectedTab.subTabs[index].isActive = subTab === selectedView;
        });
        selectedView.isActive = true;
        this.sections = selectedView.sections;
      }
    }
  }

  navigateToUrl(url: string, target: string): void {
    if (target === '_blank') {
      // Open in a new tab
      window.open(url, '_blank');
    } else {
      // Navigate in the same tab
      this._router.navigateByUrl(url);
    }
  }
  ngOnDestroy(): void {
    this.productsSubscription.unsubscribe();
  }
}
